export const PHONE_NUMBER_MASK = {
    mask: '+7 (###) ###-##-##',
}

export const OKTELL_PHONE_NUMBER_MASK = {
    mask: '8 (###) ### ####',
}

export const PHONE_NUMBER_MASK_INTERNATIONAL = {
    mask: '+# (###) ###-##-##',
}

export const PRICE_MASK = {
    mask: [
        '# ₸',
        '## ₸',
        '### ₸',
        '# ### ₸',
        '## ### ₸',
        '### ### ₸',
        '# ### ### ₸',
        '## ### ### ₸',
        '### ### ### ₸',
    ],
}

export const PRICE_MASK_WITHOUT_CURRENCY = {
    mask: [
        '#',
        '##',
        '###',
        '# ###',
        '## ###',
        '### ###',
        '# ### ###',
        '## ### ###',
        '### ### ###',
    ],
}

export const TIME_MASK = {
    mask: '##:##',
}
